interface IProjectsOrgProps {
  slug: string | undefined;
}

const ProjectsOrg = ({slug: _}: IProjectsOrgProps) => {
  return null;
};

export default ProjectsOrg;
